// extracted by mini-css-extract-plugin
module.exports = {"suspended":"_8053213","inputWrapper":"_3b66691","maxStakeCta":"_c357be6","inputDisabled":"_514c827"};